/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
import { ReactionButtonContainer_comment$ref } from "./ReactionButtonContainer_comment.graphql";
export type CreateCommentReactionInput = {
    readonly commentID: string;
    readonly commentRevisionID: string;
    readonly clientMutationId: string;
    readonly reactionType: string;
};
export type CreateCommentReactionMutationVariables = {
    readonly input: CreateCommentReactionInput;
};
export type CreateCommentReactionMutationResponse = {
    readonly createCommentReaction: {
        readonly comment: {
            readonly " $fragmentRefs": ReactionButtonContainer_comment$ref;
        } | null;
        readonly clientMutationId: string;
    } | null;
};
export type CreateCommentReactionMutation = {
    readonly response: CreateCommentReactionMutationResponse;
    readonly variables: CreateCommentReactionMutationVariables;
};



/*
mutation CreateCommentReactionMutation(
  $input: CreateCommentReactionInput!
) {
  createCommentReaction(input: $input) {
    comment {
      ...ReactionButtonContainer_comment
      id
    }
    clientMutationId
  }
}

fragment ReactionButtonContainer_comment on Comment {
  id
  revision {
    id
  }
  viewerActionPresence {
    reaction
    upvote
    downvote
  }
  actionCounts {
    reaction {
      total
    }
    upvote {
      total
    }
    downvote {
      total
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "CreateCommentReactionInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v4 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "total",
            "args": null,
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "CreateCommentReactionMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "createCommentReaction",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CreateCommentReactionPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "comment",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Comment",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ReactionButtonContainer_comment",
                                    "args": null
                                }
                            ]
                        },
                        (v2 /*: any*/)
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "CreateCommentReactionMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "createCommentReaction",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CreateCommentReactionPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "comment",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Comment",
                            "plural": false,
                            "selections": [
                                (v3 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "revision",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CommentRevision",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "viewerActionPresence",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ActionPresence",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "reaction",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "upvote",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "downvote",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "actionCounts",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ActionCounts",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "reaction",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ReactionActionCounts",
                                            "plural": false,
                                            "selections": (v4 /*: any*/)
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "upvote",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ReactionActionCounts",
                                            "plural": false,
                                            "selections": (v4 /*: any*/)
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "downvote",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ReactionActionCounts",
                                            "plural": false,
                                            "selections": (v4 /*: any*/)
                                        }
                                    ]
                                }
                            ]
                        },
                        (v2 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "mutation",
            "name": "CreateCommentReactionMutation",
            "id": "757681f50d7e4efb6fb02e307953eb8b",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '56f6cee4a85a9e43f22b59373de13555';
export default node;
